module.exports = __webpack_public_path__ + "img/mp3.6f28b800.svg";